import { render, staticRenderFns } from "./Wxkf.vue?vue&type=template&id=4ce5343f&scoped=true&"
import script from "./Wxkf.vue?vue&type=script&lang=js&"
export * from "./Wxkf.vue?vue&type=script&lang=js&"
import style0 from "./Wxkf.vue?vue&type=style&index=0&id=4ce5343f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5343f",
  null
  
)

export default component.exports